/**
 * Reducer for obtaining terms and conditions
 */
import Constants from '../constants/TermsConstants';
import { Map as IMap } from 'immutable';

const initialState = IMap({
  title: '',
  note: '',
  description: [],
});

/**
 * ## terms reducer
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function terms (state = initialState, action = null) {
  switch (action.type) {
    /**
     * ### REQUESTS (start)
     */
    case Constants.TERMS_REQUEST:
      return initialState;

    /**
     * ### SUCCESS (request ended with success)
     */
    case Constants.TERMS_SUCCESS:
      return IMap(action.data);

    /**
     * ### FAILURE (request ended with error)
     */
    case Constants.TERMS_FAILURE:
      return initialState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/TermsReducer.js